import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfModal from '@elem/ui/ef-modal';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import IconAdd from '@elem/ui/ef-tab-section/IconAdd';
import { useState } from 'react';
import styles from './index.module.scss';
import WinA from './WinA';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionE');
    const [isOpen, setIsOpen] = useState(false);
    // 打开弹窗
    const openHandle = () => {
        setIsOpen(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: 'none',
                button_name: t('btn'),
            });
        } catch (error) {}
    };
    // 关闭弹窗
    const hideHandle = () => {
        setIsOpen(false);
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                pc="https://websiteoss.ecoflow.com/upload/image/1724660572850/sectionE.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724660627786/sectionE_h5.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                hasAnimation={false}
            />
            <div className="SectionE-line">
                <div className="section-btn" onClick={openHandle}>
                    {t('btn')}
                    <span className="section-btn-icon">
                        <IconAdd />
                    </span>
                </div>
            </div>
            <EfSpec />
            {isOpen && (
                <EfModal open={isOpen} callback={hideHandle} position="center">
                    <WinA />
                </EfModal>
            )}
        </div>
    );
}
